import DOMPurify from 'dompurify';

/** Read-only evidence: opening a message must not fire tracking pixels or activate borrower links. */
export function storedEmailPreviewHtml(html: string): string {
  const body = DOMPurify.sanitize(html, {
    FORBID_TAGS: ['img', 'a', 'form', 'iframe', 'object', 'embed', 'meta', 'base', 'link', 'video', 'audio', 'source'],
    FORBID_ATTR: ['href', 'xlink:href', 'action', 'formaction', 'srcset', 'src', 'background']
  });
  return `<!doctype html><html><head><meta http-equiv="Content-Security-Policy" content="default-src 'none'; img-src data:; style-src 'unsafe-inline'; base-uri 'none'; form-action 'none'"><meta name="referrer" content="no-referrer"></head><body>${body}</body></html>`;
}
